import * as React from "react";
import { IconButton } from "@mui/material";
import { Download } from "@mui/icons-material";

import { themeColors } from "~/dashboard/theme/colors";

interface Props {
  data: Array<Record<string, string>>;
  filename?: string;
}

export const ExportCSV = ({ data, filename = "export.csv" }: Props) => {
  const handleDownload = () => {
    if (!data || !data.length) {
      alert("No data to export.");
      return;
    }

    const headers = Object.keys(data[0]);
    const csvRows = [
      headers.join(","),
      ...data.map((row) =>
        headers.map((field) => JSON.stringify(row[field] ?? "")).join(",")
      ),
    ];

    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <IconButton
      sx={{
        color: themeColors.slateDark1.palette.secondary.main,
      }}
      onClick={handleDownload}
    >
      <Download />
    </IconButton>
  );
};
